import { Play } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { type AppToolLink, buildLinkPrefill, isLinkOffered } from '@shared/app-tool-links';
import { openLinkedTool } from '@/lib/app-tool-links';
import type { AppCollection, AppRecord } from '@/lib/app-records';

const pill = 'inline-flex items-center gap-1.5 rounded-full border border-domino-cardBorder bg-domino-white px-2.5 py-0.5 text-xs text-domino-ink transition hover:border-domino-aubergine';

/**
 * S1 — the tools proposed on this object (declared in the Forge), in its line
 * of commands: each opens the tool's form prefilled from the object.
 */
export const AppRecordToolButtons = ({ links, record, collection }: { links: AppToolLink[]; record: AppRecord; collection: AppCollection }) => {
  const navigate = useNavigate();
  const offered = record.archivedAt ? [] : links.filter((link) => isLinkOffered(link, record.status));
  if (offered.length === 0) return null;
  return <>
    {offered.map((link) => (
      <button key={link.id} type="button" className={pill}
        onClick={() => openLinkedTool(navigate, link, buildLinkPrefill(link, record.computed, collection.columns))}>
        <Play className="h-3 w-3 fill-current text-domino-aubergine" aria-hidden="true" />{link.target.title}
      </button>
    ))}
  </>;
};
